/**
 * api映射处理，包含权限配置
 */

import server from './base';

//
const {
  MALL_BASE_URL,
  ORDER_BASE_URL,
  CASHBACK_BASE_URL,
  PAY_BASE_URL,
  DELIVERY_BASE_URL,
  REDEEMCODE_BASE_URL,
  COUPON_BASE_URL,
  ADVERTISE_BASE_URL,
  BOOM_BASE_URL,
  SHINE_BASE_URL,
  UC_API_URL,
  MALL_ORDER_PAY_URL,
  QUOTA_BASE_URL,
  AB_TEST_BASE_URL
} = server;

// 购物车相关
const ShopCart = {
  // 列表
  '/api/shop-cart/list': {
    method: 'POST',
    action: '/shop-cart/list',
    baseURL: SHINE_BASE_URL
  },
  // 修改sku数量
  '/api/shop-cart/updateSkuQuantity': {
    method: 'POST',
    action: '/shop-cart/updateSkuQuantity',
    baseURL: SHINE_BASE_URL
  },
  // 计算商品总价
  '/api/shop-cart/calculate': {
    method: 'POST',
    action: '/shop-cart/calculate',
    baseURL: SHINE_BASE_URL
  },
  // 清空、删除
  '/api/shop-cart/oneClickClear': {
    method: 'POST',
    action: '/shop-cart/oneClickClear',
    baseURL: SHINE_BASE_URL
  },
  // 更换sku
  '/api/shop-cart/updateSku': {
    method: 'POST',
    action: '/shop-cart/updateSku',
    baseURL: SHINE_BASE_URL
  },
  // 获取sku列表
  '/api/product/getAllSku': {
    action: '/product/getAllSku',
    method: 'GET',
    baseURL: MALL_BASE_URL
  },
  // 结算限购接口
  '/api/shop-cart/settle-now': {
    action: '/shop-cart/settle-now',
    method: 'POST',
    baseURL: SHINE_BASE_URL
  },
  // 订单确定页面
  '/api/shop-cart/confirmOrderPageCalculate': {
    action: '/shop-cart/confirmOrderPageCalculate',
    method: 'POST',
    baseURL: SHINE_BASE_URL
  },
  // 创建订单
  '/api/shop-cart/create-order': {
    action: '/shop-cart/create-order',
    method: 'POST',
    baseURL: SHINE_BASE_URL
  },
  // 合单详情接口
  '/api/order/combined/detail': {
    action: '/api/fe/order/combined/detail/{combinedOrderId}',
    method: 'GET',
    key: 'API_GET_ORDER_DETAIL',
    baseURL: ORDER_BASE_URL
  }
};

export default {
  ...ShopCart,
  // 商品相关
  '/api/item/auth': {
    method: 'GET',
    action: '/product/auth-url',
    baseURL: MALL_BASE_URL
  },
  '/api/product/detailV2': {
    action: '/product/detailV2',
    method: 'GET',
    baseURL: MALL_BASE_URL
  },
  '/v1/products': {
    action: '/v1/products/{linkCode}',
    method: 'GET',
    baseURL: MALL_BASE_URL
  },
  '/product/queryDetail': {
    action: '/product/queryDetail',
    method: 'GET',
    baseURL: MALL_BASE_URL
  },
  '/api/item/userInfo': {
    action: '/wxmp/get-user-info',
    method: 'GET',
    key: 'API_GET_WXMP_USER_INFO',
    baseURL: MALL_BASE_URL
  },
  '/api/product/prepareForOrder': {
    action: '/product/prepareForOrder',
    method: 'POST',
    key: 'API_GET_PREPARE_FOR_ORDER',
    baseURL: MALL_BASE_URL
  },
  '/api/product/prepareForOrderV2': {
    action: '/product/prepareForOrderV2',
    method: 'POST',
    key: 'API_GET_PREPARE_FOR_ORDER',
    baseURL: MALL_BASE_URL
  },
  '/api/sale-skus/id': {
    action: '/sale-skus/{id}',
    method: 'GET',
    key: 'API_GET_PREPARE_FOR_ORDER',
    baseURL: MALL_BASE_URL
  },
  '/sale-skus/recommend-skus': {
    action: '/sale-skus/{saleSkuId}/recommend-skus',
    method: 'GET',
    key: 'API_GET_RECOMMEND_SKUS',
    baseURL: MALL_BASE_URL
  },
  // 地址相关
  '/api/address/list': {
    action: '/api/fe/address/get-userAddress',
    method: 'GET',
    key: 'API_GET_ADDRESS_LIST',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/detail': {
    action: '/api/fe/address/get-userAddressById',
    method: 'GET',
    key: 'API_GET_ADDRESS_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/province': {
    action: '/api/fe/address/get-province',
    method: 'GET',
    key: 'API_GET_ADDRESS_PROVINCE',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/region': {
    action: '/api/fe/address/get-region',
    method: 'GET',
    key: 'API_GET_ADDRESS_REGION',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/create': {
    action: '/api/fe/address/create-userAddress',
    method: 'POST',
    key: 'API_CREATE_ADDRESS',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/update': {
    action: '/api/fe/address/update-userAddress',
    method: 'POST',
    key: 'API_UPDATE_ADDRESS',
    baseURL: ORDER_BASE_URL
  },
  '/api/address/delete': {
    action: '/api/fe/address/delete-userAddress',
    method: 'POST',
    key: 'API_DELETE_ADDRESS',
    serialized: true,
    baseURL: ORDER_BASE_URL
  },
  // 订单相关
  '/api/order/postOrder': {
    action: '/api/fe/order/postOrder/{orderId}',
    method: 'GET',
    key: 'API_ORDER_GET_POSTER',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/validate': {
    action: '/api/fe/place-order/validate',
    method: 'POST',
    key: 'API_ORDER_CREATE_VALIDATE',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/create': {
    action: '/api/fe/place-order/create',
    method: 'POST',
    key: 'API_ORDER_CREATE',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/validateV2': {
    action: '/api/fe/place-order/validateV2',
    method: 'POST',
    key: 'API_ORDER_CREATE_VALIDATE_V2',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/listV2': {
    action: '/api/fe/order/listV2',
    method: 'POST',
    key: 'API_GET_ORDER_LIST',
    serialized: true,
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/up/listV2': {
    action: '/api/fe/order/up/listV2',
    method: 'POST',
    key: 'API_GET_ORDER_UP_LIST',
    serialized: true,
    baseURL: ORDER_BASE_URL
  },
  '/api/place-order/createV2': {
    action: '/api/fe/place-order/createV2',
    method: 'POST',
    key: 'API_ORDER_CREATEV2',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v2/user/orders': {
    action: '/api/fe/v2/user/orders',
    method: 'POST',
    key: 'API_PROM_ORDER_CREATE',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/orders/orderId': {
    action: '/api/fe/orders/{orderId}',
    method: 'GET',
    key: 'API_GET_ORDER_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/getRedeemCodeByPhone': {
    action: '/api/fe/user/orders/{orderId}/redeem-codes',
    method: 'GET',
    key: 'API_GET_ORDER_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/sale/detail': {
    action: '/api/fe/order/sale/detail/{orderId}',
    method: 'GET',
    key: 'API_GET_ORDER_DETAIL_PRE',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/combined/detail': {
    action: '/api/fe/order/combined/detail/{combinedOrderId}',
    method: 'GET',
    key: 'API_GET_ORDER_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/pay/detail': {
    action: '/api/fe/order/get-paid-order-info',
    method: 'GET',
    key: 'API_GET_ORDER_PAY_DETAIL',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/order/pay/noRight/detail': {
    action: '/noRight/api/fe/order/get-paid-order-info',
    method: 'GET',
    key: 'API_GET_ORDER_PAY_ALIPAY_DETAIL',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/pay/list-pay-way': {
    action: '/api/fe/pay/list-pay-way',
    method: 'POST',
    key: 'API_POST_PAY-PLATFORM-LIST',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/pay/stage': {
    action: '/noRight/api/fe/pay/stage',
    method: 'POST',
    key: 'API_POST_PAY-PAY_STAGE',
    baseURL: PAY_BASE_URL
  },
  '/api/refund/list': {
    action: '/api/fe/order-request/list/{orderId}',
    method: 'GET',
    key: 'API_GET_ORDER_REFUND_LIST',
    baseURL: ORDER_BASE_URL
  },
  '/api/refund/detail': {
    action: '/api/fe/order-request/detail/{id}',
    method: 'GET',
    key: 'API_GET_ORDER_REFUND_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/oms/getDeliveryRecordByOrderId': {
    method: 'GET',
    key: 'API_GET_ORDER_DELIVERY_LIST',
    action: '/api/fe/oms/getDeliveryRecordByOrderId',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/after-sale-details': {
    method: 'POST',
    key: 'API_GET_AFTER_SALE_DETAILS',
    action: '/api/fe/return/after-sale-details',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/apply-return': {
    method: 'POST',
    key: 'API_APPLY_RETURN',
    action: '/api/fe/return/apply-return',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/cancel-return': {
    method: 'POST',
    key: 'API_CANCEL_RETURN',
    action: '/api/fe/return/cancel-return',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/list-logistics-company': {
    method: 'POST',
    key: 'API_GET_LOGISTICS_COMPANY',
    action: '/api/fe/return/list-logistics-company',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/list-refund-reason': {
    method: 'POST',
    key: 'API_GET_REFUND_REASON',
    action: '/api/fe/return/list-refund-reason',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/list-return-application': {
    method: 'POST',
    key: 'API_GET_RETURN_LIST',
    action: '/api/fe/return/list-return-application',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/queryReturnApplyList': {
    method: 'POST',
    key: 'API_GET_RETURN_APPLY_LIST',
    action: '/api/fe/return/queryReturnApplyList',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/return-application-detail': {
    method: 'POST',
    key: 'API_GET_RETURN_DETAIL',
    action: '/api/fe/return/return-application-detail',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/revoke-entity-application': {
    method: 'POST',
    key: 'API_REVOKE_RETURN_ENTITY',
    action: '/api/fe/return/revoke-entity-application',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/upload-logistics-information': {
    method: 'POST',
    key: 'API_UPLOAD_LOGISTICS_INFORMATION',
    action: '/api/fe/return/upload-logistics-information',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/return/after-sale-check': {
    method: 'POST',
    key: 'API_CHECK_AFTER_SALE',
    action: '/api/fe/return/after-sale-check',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v1/orders/originalOrderId/transfer-check': {
    method: 'POST',
    key: 'API_CHECK_TRANSFER',
    action: '/api/fe/v1/orders/{originalOrderId}/transfer-check',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/customer-order-summary': {
    method: 'GET',
    key: 'API_GET_CUSTOMER_ORDER_SUMMARY',
    action: '/api/fe/order/customer-order-summary/{orderId}',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/promotion-links/linkCode': {
    method: 'GET',
    key: 'API_GET_VALID_PROMOTION',
    action: '/api/fe/promotion-links/{linkCode}',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/configs': {
    method: 'GET',
    key: 'API_GET_MALL_CONFIG',
    action: '/api/fe/configs',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/user/orders': {
    method: 'GET',
    key: 'API_GET_ORDER_LIST_BY_ADDRESS',
    action: '/api/fe/user/orders',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order-addresses/batch-update': {
    method: 'POST',
    key: 'API_SET_ORDER_ADDRESS',
    action: '/api/fe/order-addresses/batch-update',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v1/support-ticket-reasons': {
    method: 'GET',
    key: 'API_GET_CHANGE_CONTENT_REASON',
    action: '/api/fe/v1/support-ticket-reasons',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v1/user/support-tickets': {
    method: 'POST',
    key: 'API_CREATE_TRANSFER_ORDER',
    action: '/api/fe/v1/user/support-tickets',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v1/user/support-tickets/ticketId-delete': {
    method: 'PUT',
    key: 'API_DELTE_TRANSFER_ORDER',
    action: '/api/fe/v1/user/support-tickets/{ticketId}',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/v1/user/support-tickets/ticketId-detail': {
    method: 'GET',
    key: 'API_GET_TRANSFER_ORDER',
    action: '/api/fe/v1/user/support-tickets/{ticketId}',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/orders/orderId/cancel': {
    method: 'POST',
    key: 'API_CANCEL_ORDER',
    action: '/api/fe/orders/{orderId}/cancel',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/user/orders/precheck': {
    method: 'POST',
    key: 'API_CANCEL_ORDER',
    action: '/api/fe/user/orders/precheck',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/orders/originalOrderId/calculate-transfer-fee': {
    method: 'POST',
    key: 'API_CALCULATE_TRANSFER_FEE',
    action: '/api/fe/orders/{originalOrderId}/calculate-transfer-fee',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/prom-order-settlement/coupon': {
    method: 'GET',
    key: 'API_GET_VALID_PROMOTION',
    action: '/api/fe/users/{userId}/coupons',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/address/list': {
    action: '/api/fe/order/get-address',
    method: 'GET',
    key: 'API_GET_ORDER_ADDRESS_LIST',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/valid': {
    action: '/api/fe/order/valid/{orderId}',
    method: 'GET',
    key: 'API_GET_ORDER_VALID',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/get-address/detail/v2': {
    action: '/api/fe/order/get-address/detail/v2/{orderId}',
    method: 'GET',
    key: 'API_GET_ORDER_ADDRESS_DETAIL_V2',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/modify-address/v2': {
    action: '/api/fe/order/modify-address/v2',
    method: 'POST',
    key: 'API_POST_ORDER_MODIFY_ADDRESS_V2',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/order/get-modify-address': {
    action: '/api/fe/order/get-modify-address',
    method: 'GET',
    key: 'API_GET_ORDER_MODIFY_RES',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/address/update': {
    action: '/api/fe/order/modify-address',
    method: 'POST',
    key: 'API_GET_ORDER_ADDRESS_UPDATE',
    baseURL: ORDER_BASE_URL
  },
  '/api/order/pay': {
    action: '/api/fe/pay/create-wechatOrderJSAPI',
    method: 'POST',
    key: 'API_ORDER_TO_PAY',
    baseURL: PAY_BASE_URL
  },
  '/api/order/get-alipay-html': {
    action: '/noRight/api/fe/pay/create-wap-alipay-order',
    method: 'POST',
    key: 'API_GET_ALIPAY_HTML',
    baseURL: PAY_BASE_URL
  },
  '/api/order/get-alipay-qrcode': {
    action: '/api/fe/pay/create-qr-alipay-order',
    method: 'POST',
    key: 'API_GET_ALIPAY_QRCODE',
    baseURL: PAY_BASE_URL
  },
  '/api/order/get-alipay-token': {
    action: '/api/fe/pay/get-pay-order-token',
    method: 'POST',
    key: 'API_GET_ALIPAY_TOKEN',
    baseURL: PAY_BASE_URL
  },
  '/api/order/query-pay-result': {
    action: '/api/fe/pay/pull-pay-result',
    method: 'GET',
    key: 'API_QUERY_WECHAT_ORDER',
    baseURL: PAY_BASE_URL
  },
  '/api/fe/pay/pull-pay-resultV2': {
    action: '/api/fe/pay/pull-pay-resultV2',
    method: 'POST',
    key: 'API_PULL_PAY_RESULTV2',
    baseURL: PAY_BASE_URL
  },
  '/noRight/api/fe/pay/pull-pay-result': {
    action: 'noRight/api/fe/pay/pull-pay-result',
    method: 'GET',
    key: 'API_QUERY_WECHAT_ORDER',
    baseURL: PAY_BASE_URL
  },
  '/api/cartoon/aliPay': {
    action: '/noRight/api/cartoon/aliPay',
    method: 'POST',
    key: 'API_QUERY_CARTOON_ALIPAY_ORDER',
    baseURL: PAY_BASE_URL
  },
  '/api/cartoon/wxPay': {
    action: '/noRight/api/cartoon/wxPay',
    method: 'POST',
    key: 'API_QUERY_CARTOON_WECHAT_ORDER',
    baseURL: PAY_BASE_URL
  },
  '/api/fe/cartoon/wechat/getPayInfo': {
    action: '/api/fe/cartoon/getPayInfo',
    method: 'POST',
    key: 'API_QUERY_CARTOON_WECHAT_PAY_INFO',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/cartoon/alipay/getPayInfo': {
    action: '/noRight/api/fe/cartoon/getPayInfo',
    method: 'POST',
    key: 'API_QUERY_CARTOON_ALIPAY_PAY_INFO',
    baseURL: ORDER_BASE_URL
  },
  // 发票列表接口
  '/api/fe/orderInvoice/list': {
    action: '/api/fe/orderInvoice/list',
    method: 'POST',
    key: 'API_FE_ORDER_INVOICE_LIST',
    baseURL: ORDER_BASE_URL
  },
  // 物流相关
  '/api/delivery/detail': {
    action: '/delivery/getDeliveryRecordById',
    method: 'GET',
    key: 'API_DELIVERY_DETAIL',
    baseURL: DELIVERY_BASE_URL
  },
  '/api/fe/oms/logistics': {
    action: '/api/fe/oms/logistics',
    method: 'GET',
    key: 'API_DELIVERY_OMS_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/deliveryPage/queryMyDelivery': {
    action: '/api/fe/deliveryPage/queryMyDelivery',
    method: 'GET',
    key: 'API_DELIVERY_LIST',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/deliveryPage/queryTrace': {
    action: '/api/fe/deliveryPage/queryTrace',
    method: 'GET',
    key: 'API_DELIVERY_TRACE',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/deliveryPage/queryMyOrder': {
    action: '/api/fe/deliveryPage/queryMyOrder',
    method: 'GET',
    key: 'API_DELIVERY_LIST',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/deliveryPage/queryOrderDetail': {
    action: '/api/fe/deliveryPage/queryOrderDetail',
    method: 'GET',
    key: 'API_DELIVERY_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  // 激活码相关
  '/api/exchange/code/validate': {
    action: '/api/fe/redeem-code/redeem-validate/{redeemCode}',
    method: 'GET',
    key: 'API_EXCHANGE_CODE_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/exchange/code/detail': {
    action: '/api/fe/redeem-code/redeem-detail/{redeemCode}',
    method: 'GET',
    key: 'API_EXCHANGE_CODE_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/redeem-code/redeem-detail/productDetail': {
    action: '/api/fe/redeem-code/redeem-detail/productDetail',
    method: 'POST',
    key: 'API_EXCHANGE_PRODUCE_DETAIL',
    baseURL: ORDER_BASE_URL
  },
  '/api/exchange/code/active': {
    action: '/api/fe/redeem-code/redeem',
    method: 'POST',
    key: 'API_EXCHANGE_CODE_ACTIVE',
    baseURL: ORDER_BASE_URL
  },
  //
  '/api/activate/code': {
    action: '/redeemcode/sendSmsForRedeemCodeSearchV2',
    method: 'POST',
    key: 'API_ACTIVATE_CODE',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/api/activate/phoneSearch/code': {
    action: '/redeemcode/sendSmsForSearchingUnactivatedRedeemCodeV2',
    method: 'POST',
    key: 'API_ACTIVATE_CODE',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/api/phoneSearch/exchange': {
    action: '/redeemcode/searchUnactivatedRedeemCode',
    method: 'GET',
    key: 'API_ACTIVATE_CODE',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/api/activate/check': {
    action: 'redeemcode/checkVCode',
    method: 'GET',
    key: 'API_ACTIVATE_CHECK',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/api/activate/query': {
    action: '/redeemcode/searchRedeemCodeByPhone',
    method: 'GET',
    key: 'API_ACTIVATE_QUERY',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/redeemcode/checkUnactivatedRedeemCodeSearchVCode': {
    action: '/redeemcode/checkUnactivatedRedeemCodeSearchVCode',
    method: 'GET',
    key: 'API_CHECKVCODE_QUERY1',
    baseURL: REDEEMCODE_BASE_URL
  },
  '/api/fe/course/user/activateV2': {
    action: '/api/fe/course/user/activateV2',
    method: 'POST',
    key: 'API_COURSE_ACTIVATE_QUERY',
    baseURL: QUOTA_BASE_URL
  },
  '/api/fe/course/user/queryActivateV2': {
    action: '/api/fe/course/user/queryActivateV2',
    method: 'POST',
    key: 'API_COURSE_ACTIVATE_ORDER_QUERY',
    baseURL: QUOTA_BASE_URL
  },
  '/api/fe/course/user/validateActivate': {
    action: '/api/fe/course/user/validateActivate',
    method: 'POST',
    key: 'API_COURSE_ACTIVATE_VALIDATE',
    baseURL: QUOTA_BASE_URL
  },

  '/api/wx/config': {
    action: '/wxmp/create-signature',
    baseURL: MALL_BASE_URL
  },
  '/api/order/hot-user-info': {
    baseURL: ORDER_BASE_URL,
    action: '/noRight/api/fe/order/get-hot-user-info'
  },

  // 优惠券
  '/api/coupon/product-coupon': {
    baseURL: COUPON_BASE_URL,
    action: '/coupon/product-coupon'
  },
  '/api/coupon/product-coupon-list': {
    baseURL: COUPON_BASE_URL,
    action: '/coupon/product-coupon-list'
  },
  '/products/productId/coupons': {
    baseURL: COUPON_BASE_URL,
    action: '/products/{productId}/coupons',
    method: 'GET'
  },
  '/api/activity/detail': {
    baseURL: COUPON_BASE_URL,
    action: '/coupon-activities/{activityId}'
  },
  '/api/activity/batch-pick': {
    baseURL: COUPON_BASE_URL,
    method: 'POST',
    action: '/user/coupons'
  },
  '/api/product/link-product': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    // headers: { 'content-type': 'application/x-www-form-urlencoded' },
    action: '/product/link-product'
  },
  '/api/activity/list-available-user-coupon': {
    baseURL: COUPON_BASE_URL,
    action: '/activity/list-available-user-coupon'
  },
  '/users/userId/coupons': {
    baseURL: COUPON_BASE_URL,
    action: '/users/{userId}/coupons'
  },
  '/api/activity/list-valid-user-coupon': {
    baseURL: COUPON_BASE_URL,
    action: '/activity/list-valid-user-coupon'
  },
  '/v1/user/voucher-assets': {
    baseURL: COUPON_BASE_URL,
    action: '/v1/user/voucher-assets'
  },
  '/noRight/promotion-links/linkCode/classes': {
    baseURL: COUPON_BASE_URL,
    action: '/noRight/promotion-links/{linkCode}/classes'
  },
  '/shop/detail': {
    baseURL: MALL_BASE_URL,
    action: '/shop/detail'
  },
  '/shop-product-list/categoryTree': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop-product-list/categoryTree'
  },
  '/shop-product-list/getConfigMessage': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop-product-list/getConfigMessage'
  },
  '/shop-product-list/getProducts': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop-product-list/getProducts'
  },
  '/shop-product-list/getPointAndUrl/{id}': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop-product-list/getPointAndUrl/{id}'
  },
  '/shop/search-record': {
    baseURL: MALL_BASE_URL,
    action: '/shop/search-record'
  },
  '/shop/announcement-list': {
    baseURL: MALL_BASE_URL,
    action: '/shop/announcement-list'
  },
  // '/shop/announcement-list-head': {
  //   baseURL: MALL_BASE_URL,
  //   action: '/shop/announcement-list-head',
  // },
  '/shop/banner-detail': {
    baseURL: MALL_BASE_URL,
    action: '/shop/banner-detail'
  },
  // '/shop/closing': {
  //   baseURL: MALL_BASE_URL,
  //   action: '/shop/closing',
  // },
  '/shop/delete-search-record': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop/delete-search-record'
  },
  '/shop/more-product-list': {
    baseURL: MALL_BASE_URL,
    action: '/shop/more-product-list'
  },
  '/shop/search-product-list': {
    baseURL: MALL_BASE_URL,
    action: '/shop/search-product-list'
  },
  '/shop/save-module-visit-record': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/shop/save-module-visit-record'
  },
  '/shop/integral-rules': {
    baseURL: MALL_BASE_URL,
    action: '/shop/integral-rules'
  },
  '/argument/list': {
    baseURL: ORDER_BASE_URL,
    action: '/api/fe/argument/list'
  },
  '/argument/record-details': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/argument/record-details'
  },
  '/argument/argument-detail': {
    baseURL: ORDER_BASE_URL,
    action: '/api/fe/argument/argument-detail/{argumentId}'
  },
  '/api/fe/v1/agreements': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/v1/agreements'
  },
  '/argument/unsign': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/argument/unsign'
  },
  '/argument/argument-result': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/argument/argument-result/{argumentDraftId}'
  },
  '/api/fe/v1/agreements/renewals': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/v1/agreements/{agreementId}/renewals'
  },
  '/api/fe/v1/agreements/sign-ways': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/v1/agreements/sign-ways'
  },
  '/wechatMiniProgram/getSchemaUrl': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/wechatMiniProgram/getSchemaUrl'
  },
  '/pay/get-sign-and-pay-body': {
    baseURL: PAY_BASE_URL,
    method: 'GET',
    action: '/noRight/api/fe/pay/get-sign-and-pay-body'
  },
  '/get-sign-url': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/noRight/api/fe/order/get-sign-url/{token}'
  },
  '/wxmp/linkJump': {
    baseURL: MALL_BASE_URL,
    method: 'GET',
    action: '/wxmp/linkJump'
  },
  '/advertisement/findAd': {
    baseURL: ADVERTISE_BASE_URL,
    method: 'get',
    action: '/advertisement/findAd'
  },
  '/upgrade/detail': {
    baseURL: ORDER_BASE_URL,
    method: 'get',
    serialized: true,
    action: '/api/fe/upgrade/detail'
  },
  '/upgrade/confirmToUpgrade': {
    baseURL: ORDER_BASE_URL,
    method: 'get',
    action: '/api/fe/upgrade/confirmToUpgrade'
  },
  '/upgrade/get-paid-order-info': {
    baseURL: MALL_ORDER_PAY_URL,
    method: 'get',
    action: '/api/fe/upgrade/get-paid-order-info'
  },
  '/product/auto-subscription': {
    baseURL: MALL_BASE_URL,
    method: 'get',
    action: '/product/auto-subscription'
  },
  '/api/fe/order/check-auto-active': {
    action: '/api/fe/order/check-auto-active',
    method: 'GET',
    baseURL: ORDER_BASE_URL
  },
  '/order/queryGroupBookingOrder': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/order/queryGroupBookingOrder/{activityCode}'
  },
  '/pay/create-CMBC-pay-order': {
    baseURL: PAY_BASE_URL,
    method: 'POST',
    action: '/api/fe/pay/create-CMBC-pay-order'
  },
  '/pay/create-BOC-pay-order': {
    baseURL: PAY_BASE_URL,
    method: 'POST',
    action: '/noRight/api/fe/pay/create-BOC-pay-order'
  },
  '/product/check-retain': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/product/check-retain'
  },
  '/product/pick-retain-coupon': {
    baseURL: MALL_BASE_URL,
    method: 'POST',
    action: '/product/pick-retain-coupon/{couponId}'
  },
  '/order/apply-fee': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/apply-fee'
  },
  '/order/rights-paid-records': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/order/rights-paid-records'
  },
  '/order/get-paid-bill-info': {
    baseURL: MALL_ORDER_PAY_URL,
    method: 'GET',
    action: '/api/fe/order/get-paid-bill-info'
  },
  '/noRight/api/fe/order/get-paid-bill-info': {
    baseURL: MALL_ORDER_PAY_URL,
    method: 'GET',
    action: '/noRight/api/fe/order/get-paid-bill-info'
  },
  '/reserve/action-reserve': {
    baseURL: BOOM_BASE_URL,
    method: 'POST',
    action: '/reserve/action-reserve'
  },
  '/shop-cart/addSku': {
    baseURL: SHINE_BASE_URL,
    method: 'POST',
    action: '/shop-cart/addSku'
  },
  '/shop-cart/getShopCartNum': {
    baseURL: SHINE_BASE_URL,
    method: 'POST',
    action: '/shop-cart/getShopCartNum'
  },
  '/api/product/getAllSku': {
    action: '/product/getAllSku',
    method: 'GET',
    baseURL: MALL_BASE_URL
  },
  '/activity/getRetainPopup': {
    baseURL: BOOM_BASE_URL,
    method: 'GET',
    action: '/activity/getRetainPopup'
  },
  '/pay/create-pay-order': {
    baseURL: PAY_BASE_URL,
    method: 'POST',
    action: '/api/fe/pay/create-pay-order'
  },
  '/api/fe/user': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/user'
  },
  '/api/user-center/common/useNewLogin': {
    baseURL: UC_API_URL,
    method: 'GET',
    action: '/api/user-center/common/useNewLogin'
  },
  '/ResolveBoolean': {
    method: 'POST',
    baseURL: AB_TEST_BASE_URL,
    action: '/ResolveBoolean',
    credentials: 'omit'
  },
  '/api/fe/address/get-ipAddress': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/address/get-ipAddress'
  },
  '/api/fe/address/modifyDefaultAdderss': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/address/modifyDefaultAdderss'
  },
  '/api/fe/order/modifyAddress/detail': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/modifyAddress/detail'
  },
  '/api/fe/order/modifyOrderAddress': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/modifyOrderAddress'
  },
  '/api/fe/order/queryModifyAddressResult': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/queryModifyAddressResult'
  },
  '/api/fe/order/queryRegionCode': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/queryRegionCode'
  },
  '/api/fe/order/queryModifyAddressSwitch': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/queryModifyAddressSwitch'
  },
  '/api/fe/order/modifyAddressAfterOrder': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/order/modifyAddressAfterOrder'
  },
  '/api/fe/buy-limit/validate': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/buy-limit/validate'
  },
  '/api/fe/buy-limit/validate-phone': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/buy-limit/validate-phone'
  },
  '/api/fe/buy-limit/sendSmsMessageCode': {
    baseURL: ORDER_BASE_URL,
    method: 'POST',
    action: '/api/fe/buy-limit/sendSmsMessageCode'
  },
  '/api/fe/oms/delivery_plan': {
    baseURL: ORDER_BASE_URL,
    method: 'GET',
    action: '/api/fe/oms/delivery_plan'
  },
  '/api/fe/activities/gifts/get': {
    baseURL: MALL_BASE_URL,
    method: 'GET',
    action: '/activities/{activityId}/gifts'
  },
  '/api/fe/activities/gifts/put': {
    baseURL: MALL_BASE_URL,
    method: 'PUT',
    action: '/activities/{activityId}/gifts/{giftId}'
  },
  '/cashback/noRight/apollo/get-by-key': {
    baseURL: CASHBACK_BASE_URL,
    method: 'GET',
    action: '/noRight/apollo/get-by-key'
  }
};
